import { ForwardedRef, forwardRef, useImperativeHandle, useState } from 'react'
// Material
import { Badge } from '@mui/material'
import { styled } from '@mui/material/styles'
// Common
import { UserAvatar } from '$common/avatar'
import { WithEditableAvatar } from '$common/with-editable-avatar'
// Icons
import { ProfilePictureMenu } from '$comp/modals/menus/profile-picture-menu'
import { getClientUser } from '$logic/client-user'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const StyledBox = styled(Badge)(() => ({
  display: 'flex',
  margin: '0 auto',
  marginBottom: '16px',
}))

const StyledUserAvatar = styled(UserAvatar)`
  border: 5px solid white;
  // TODO: Pick random bgcolor
  background-color: #455a64;
  cursor: pointer;
`

export interface EditAccountImageApiType {
  get: () => string
}

export const EditAccountProfileBox = forwardRef(
  function EditAccountProfileBoxComponent(_, ref: ForwardedRef<unknown>) {
    const clientUser = getClientUser()
    const [imageFileId, setImageFileId] = useState<string | undefined>(
      clientUser.image,
    )

    useImperativeHandle(ref, () => ({ get: () => imageFileId || '' }), [
      imageFileId,
    ])

    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [menuLocation, setMenuLocation] = useState({ xAxis: 0, yAxis: 0 })
    const onMenuClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      setMenuLocation({ xAxis: e.clientX, yAxis: e.clientY })
      setIsMenuOpen(!isMenuOpen)
    }

    return (
      <StyledBox>
        <WithEditableAvatar onSelectClick={onMenuClick}>
          <StyledUserAvatar
            userId={clientUser.id}
            size={AvatarSize._3XL}
            overrideImage={imageFileId}
            openImageViewer
            imageCompressionWidth={160}
          />
        </WithEditableAvatar>
        {isMenuOpen && (
          <ProfilePictureMenu
            showDelete={!!imageFileId}
            onSubmit={setImageFileId}
            onClose={() => setIsMenuOpen(false)}
            xAxis={menuLocation.xAxis}
            yAxis={menuLocation.yAxis}
          />
        )}
      </StyledBox>
    )
  },
)
